export const RATE_TYPE_KEY_ENUM = {
  userRates: 'userRates',
  roleRates: 'roleRates'
};
